const colors = {
  semiblack: "#231f20",
  black: "#111111",
  semiwhite: "#e1e1e7",
  white: "#f1f1f5"
};

export { colors };



// WEBPACK FOOTER //
// ./src/Twitch/var.js